
const /** @type {?} */ availablePrefixs = ['moz', 'ms', 'webkit'];
/**
 * @return {?}
 */
function requestAnimationFramePolyfill(): typeof requestAnimationFrame {
  let /** @type {?} */ lastTime = 0;
  return function (callback: FrameRequestCallback): number {
    const /** @type {?} */ currTime = new Date().getTime();
    const /** @type {?} */ timeToCall = Math.max(0, 16 - (currTime - lastTime));
    const /** @type {?} */ id = window.setTimeout(() => { callback(currTime + timeToCall); }, timeToCall);
    lastTime = currTime + timeToCall;
    return id;
  };
}
/**
 * @return {?}
 */
function getRequestAnimationFrame(): typeof requestAnimationFrame {
  if (typeof window === 'undefined') {
    return () => null;
  }
  if (window.requestAnimationFrame) {
    // https://github.com/vuejs/vue/issues/4465
    return window.requestAnimationFrame.bind(window);
  }

  const /** @type {?} */ prefix = availablePrefixs.filter(key => `${key}RequestAnimationFrame` in window)[0];

  return prefix
    ? window[`${prefix}RequestAnimationFrame`]
    : requestAnimationFramePolyfill();
}

export const /** @type {?} */ reqAnimFrame = getRequestAnimationFrame();
